<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { isActionVisible } from "@/components/utils/actions";
import { injectStrict } from "@/utils/vue";

import EnablingTeam from "./EnablingTeam.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("depend", card, board.value));
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.setDepend">
    <EnablingTeam />
  </ActionMenuDropdown>
</template>
